import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "footer-area bg-white text-center rounded-top-7",
  style: {"line-height":"1rem"}
}
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "fs-14" }

import { t } from '@/utils/i18nHelper';
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'MainFooter',
  setup(__props) {

const currentYear = computed(() => new Date().getFullYear());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("p", {
      style: {"line-height":"inherit"},
      class: "text-muted small mb-0 pb-0",
      innerHTML: _unref(t)('common.footer.disclaimer', 'Le informazioni e i calcoli forniti da questo strumento sono simulazioni a scopo puramente informativo e non costituiscono una consulenza fiscale o legale. Per una valutazione accurata della tua posizione, rivolgiti sempre a un professionista qualificato.')
    }, null, 8, _hoisted_2),
    _createElementVNode("p", _hoisted_3, [
      _createElementVNode("small", null, [
        _createElementVNode("span", null, "Smart Rate® Copyright " + _toDisplayString(currentYear.value) + " All Rights Reserved | P.IVA 04195250362 | Made with ❤ by ", 1),
        _cache[0] || (_cache[0] = _createElementVNode("a", {
          href: "https://cactus.farm",
          target: "_blank",
          class: "text-decoration-none text-muted"
        }, "Cactus Farm srl", -1))
      ])
    ])
  ]))
}
}

})